import { ListingDefaultsFormValues, ListingTemplateFormValues } from "./types";

export const initialListingDefaultsForm: ListingDefaultsFormValues = {
  contactUserIds: [],
  locationOfficeIds: [],
  contacts: [],
  offices: [],
  locationCountyCode: "",
  locationMunicipalityCode: "",
  locationSettlementCode: "",
  locationManualAddress: "",
  locationDisplay: "approximate",
  priceIncludesImport: "",
  paymentOptions: {},
  warrantyCode: "",
  extendedWarranty: false,
  g1ClubWarranty: false,
  videoCallViewing: false,
};

export const initialListingTemplateForm: ListingTemplateFormValues = {
  name: "",
  titleTemplate: "",
  descriptionTemplate: "",
  isDefault: false,
};

/**
 * Varijable koje se pri primjeni predloška zamjenjuju podacima vozila.
 * Zamjena se radi na frontendu (LISTING wizard ima cijelo vozilo u stanju).
 */
export const LISTING_TEMPLATE_VARIABLES: { code: string; label: string }[] = [
  { code: "marka", label: "Marka" },
  { code: "model", label: "Model" },
  { code: "tip", label: "Tip" },
  { code: "godina", label: "Godina proizvodnje" },
  { code: "kilometraza", label: "Prijeđeni kilometri" },
  { code: "snaga", label: "Snaga motora" },
  { code: "gorivo", label: "Gorivo" },
  { code: "mjenjac", label: "Mjenjač" },
  { code: "boja", label: "Boja" },
  { code: "vin", label: "VIN" },
  { code: "registracija", label: "Registracijska oznaka" },
];
